import { Component, Inject, OnInit } from '@angular/core';
import {
   AbstractControl,
   UntypedFormBuilder,
   UntypedFormGroup,
   ValidationErrors,
   ValidatorFn,
   Validators,
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { containsCharactersValidator } from 'src/app/common-components/validators/contain-characters.validator';
import { ModifyDepartmentFormData } from '../department-register/models/modify-department-form-data';
import { selectDepartmentNames } from '../department-register/state/department-register.selectors';
import { ModifyDepartmentForm } from './models/modify-department.form';

@Component({
    selector: 'ndt-modify-department',
    templateUrl: './modify-department.component.html',
    standalone: false
})
export class ModifyDepartmentComponent implements OnInit {
   form: UntypedFormGroup;

   departmentNames: string[];

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: ModifyDepartmentFormData,
      private dialogRef: MatDialogRef<ModifyDepartmentComponent>,
      private fb: UntypedFormBuilder,
      private store: Store
   ) {}

   ngOnInit(): void {
      this.store.select(selectDepartmentNames).subscribe((names) => {
         this.departmentNames = names;
      });
      const form: ModifyDepartmentForm = {
         name: this.fb.control(this.data.departmentName ?? null, [
            Validators.required,
            this.uniqueNameValidator(),
            containsCharactersValidator(),
         ]),
      };
      this.form = this.fb.group(form);
   }

   onSubmit(): void {
      if (this.form.valid) {
         this.dialogRef.close({ departmentId: this.data.departmentId, name: this.form.value.name });
      }
   }

   onCloseClick(): void {
      this.dialogRef.close(null);
   }

   private uniqueNameValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
         const name = control.value;
         if (!name) return null;
         if (name === this.data.departmentName) return null;
         const isNameUnique = this.departmentNames.find((departmentName) => departmentName === name) ? false : true;
         return isNameUnique ? null : { uniqueName: true };
      };
   }
}
